
import Result, { EmptyResult } from '../Result';

import LocalStorage, { Record, Storage, SessionStorage } from './';

export default class StorageManager {
  private storages: Array<Storage>;

  public constructor(private rootKey: string) {
    this.storages = [new LocalStorage(), new SessionStorage()];
  }

  public async put(key: string, value: unknown, isPermanent = true): Promise<Result> {
    try {
      const recordKey = this.prepareRecordKey(key);
      const recordValue = this.prepareRecordValue(value);
      const record = new Record(recordKey, recordValue, isPermanent);

      for (const storage of this.storages) {
        void storage.put(record);
      }

      return new EmptyResult();
    } catch (error) {
     console.error('Error during storage put operation', error);

      throw error;
    }
  }

  public async delete(key: string): Promise<Result> {
    try {
      const recordKey = this.prepareRecordKey(key);

      for (const storage of this.storages) {
        const { data } = await storage.delete(recordKey);

        if (data) {
          break;
        }
      }

      return new EmptyResult();
    } catch (error) {
      console.error('Error during storage delete operation', error);

      throw error;
    }
  }

  public async get(key: string): Promise<Result<string | null>> {
    try {
      const recordKey = this.prepareRecordKey(key);
      let value: string | null = null;

      for (const storage of this.storages) {
        const { data } = await storage.get(recordKey);

        if (data) {
          value = data;
          break;
        }
      }

      return new Result(value);
    } catch (error) {
      console.error('Error during storage get operation', error);

      throw error;
    }
  }

  private prepareRecordKey(key: string): string {
    return `${this.rootKey}_${key}`;
  }

  private prepareRecordValue(value: unknown): string {
    return typeof value === 'object' ? JSON.stringify(value) : String(value);
  }
}
